import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Row, Col, Card } from "react-bootstrap"
import CTextBox from '../../../Common/CTextBox';
import CDatePicker from '../../../Common/CDatePicker';
import Message from '../../../Common/Message';
import { Toggle } from '@fluentui/react/lib/Toggle';
import CTextArea from '../../../Common/CTextArea';
import { useBoolean } from '@fluentui/react-hooks';
import List from '../../../Templates/List';
import { OverflowSet } from '@fluentui/react/lib/OverflowSet';
import Picker from '../../../Common/Picker';
import CValidator from '../../../Common/CValidator';
import { DefaultButton, PrimaryButton } from '@fluentui/react/lib/Button';
import { Panel, PanelType } from '@fluentui/react/lib/Panel';
import { Dialog, DialogFooter, DialogType } from '@fluentui/react/lib/Dialog';
import { saveMessage, saveMessageVisa, updateMessage } from "../../../../services/sBook/message.service"
import { useGetMessageTopics, useGetSectionPartyFullsByBookId, useGetSectionsByPartyId } from "../../../../hooks/services/sBook/useOfSection"
import { useGetDocumentListByMessage } from '../../../../hooks/services/sBook/useOfDocument';
import { ActionButton } from '@fluentui/react/lib/Button';
import DocumentLinkModal from './DocumentLinkModal';
import { getKeyByValue, isBookApprover, isNullUndefined, joinWithoutDupes, visibilityButtonSaveWMessageId, visibilityButtonSend, visibilityButtonSendToApprove, visibilityControlSendToVisa } from '../../../../common/Helpers';
import { __DocumentTypeKeys, enum__BOOK_SECTION_CLASS, enum__MessageStatus } from '../../../../common/Dictionaries';
import { addListDocumentByMessage, removeDocumentByMessageDocument } from '../../../../services/sBook/document.service';
import moment from "moment-timezone"
import ListPagination from '../../../Templates/List/ListPagination';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../common/CommonFuctions';
import { _global_buttonStyles } from '../../../../common/ObjectStructures/Trasnversal';
import SidePanelCreateWithTemplate from './SidePanelCreateWithTemplate';
import { action_setFireBook } from '../../../../reducers/actions/Book/actions';
import { useDispatch } from 'react-redux';
import { cloneDeep } from 'lodash-es';
import { ChoiceGroup, Dropdown, SpinnerSize } from '@fluentui/react';
import { useGetDistributionGroupsMaintainer, useGetListUserDistributionGroup } from '../../../../hooks/services/NotificationTask/useOfDistributionGroups';
import CLabel from '../../../Common/CLabel';
import Loading from '../../../Templates/Site/Loading';

function SidePanelCreate(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();

    //Parametros de entrada.
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_CurrentUserName = props.currentUserName !== null && props.currentUserName !== undefined ? props.currentUserName : null;
    const inputParam_IsPanelOpen = props.isPanelOpen;
    const inputParam_SetterIsPanelOpen = props.setterIsPanelOpen;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;
    
    //Parametros de componente.
    const [isDialogVisible, { setTrue: showDialog, setFalse: hideDialog }] = useBoolean(false);
    
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [itemToDelete, setItemToDelete] = useState(null);

    const [isModalDocumentOpen, setIsModalDocumentOpen] = useState(false);
    const [isTemplatePanelOpen, setIsTemplatePanelOpen] = useState(false);
    
    
    const [txtNameIsInValid, setTxtNameIsInValid] = useState(false)
    const [txtCodeIsInValid, setTxtCodeIsInValid] = useState(false)
    const [txtBodyIsInValid, setTxtBodyIsInValid] = useState(false)
    const [pickerAnswerDeadlineDateIsInValid, setPickerAnswerDeadlineDateIsInValid] = useState(false)
    const [isInvalidSection, setIsInvalidSection] = useState(false);
    const [isInvalidSectionParty, setIsInvalidSectionParty] = useState(false);

    const [isInvalidDistributionGroupUserList, setIsInvalidDistributionGroupUserList] = useState(false);
    const [isInvalidDistributionGroupList, setIsInvalidDistributionGroupList] = useState(false);
    
    const [isInvalidTemplateSection, setIsInvalidTemplateSection] = useState(false);
    const [topicList, setTopicList] = useState(null);
    useGetMessageTopics(topicList, setTopicList, true);

    const [objMensaje, setObjMensaje] = useState({
        id: null,
        book_id: inputParam_BookObject.id,
        section_id: null,
        section_party_member_id: null,
        section_party_from_id: null,
        item_message: { 
            id: null,
            sectionId: null,
            messageNemo: "",
            messageCode: " ",
            correlative: 0,
            title: "",
            body: "",
            topicId: 1,
            senderUsername: inputParam_CurrentUserName,
            sectionPartySenderId: null,
            sendDate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
            answerNeeded: false,
            answerToMessage: false,
            answerMessageNemo: null,
            answerMessageId: null,
            answerDeadlineDate: null,
            attacheds: null,
            deactivate: false,
            statusId: null,
            visa: null
        },
        l_section_party_to_ids: []
    });
    
    
    const [selectedDistributionGroup, setSelectedDistributionGroup] = useState(null);
    const [distributionGroupList, setDistributionGroupList] = useState(null);
    useGetDistributionGroupsMaintainer(distributionGroupList, setDistributionGroupList)

    const [fireDistributionGroupSearch, setFireDistributionGroupSearch] = useState(false);
    const [distributionGroupUsersList, setDistributionGroupUsersList] = useState(null);
    useGetListUserDistributionGroup(!isNullUndefined(selectedDistributionGroup) ? selectedDistributionGroup.id : null, distributionGroupUsersList, setDistributionGroupUsersList, inputParam_IsPanelOpen, fireDistributionGroupSearch, setFireDistributionGroupSearch)

    const documentUploadDisabled = objMensaje.item_message.id === null;

    const [fireEvent, setFireEvent] = useState(false);

    const [sectionList, setSectionList] = useState(null);
    const [fireGetSectionByParties, setFireGetSectionByParties] = useState(true);
    useGetSectionsByPartyId(
        inputParam_UserProps.partyId, 
        inputParam_UserProps.partyMemberId, 
        sectionList, 
        setSectionList, 
        null, 
        true, 
        false, 
        [], 
        inputParam_IsPanelOpen,
        null,
        {fireGetSectionByParties,
        setFireGetSectionByParties});
    
    const [sectionPartyList, setSectionPartyList] = useState(null);
    useGetSectionPartyFullsByBookId(inputParam_BookObject.id, objMensaje.section_id, sectionPartyList, setSectionPartyList, null, fireEvent, setFireEvent, true);

    const [dataFilled, setDataFilled] = useState(false);
    const [documentMessageList, setDocumentMessageList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});
    useGetDocumentListByMessage(objMensaje.item_message.id, documentMessageList, setDocumentMessageList, inputParam_IsPanelOpen, dataFilled, setDataFilled)

    const [hideActionButtons, setHideActionButtons] = useState(false);

    //Funciones de componente.

    //Eventos de componente.
    const isInValidFormControl = () => {
        let isInvalidForm = false;

        if (objMensaje.item_message.messageCode === "") {
            setTxtCodeIsInValid(true);
            isInvalidForm = true;
        }
        else {
            setTxtCodeIsInValid(false);
        }

        if (objMensaje.item_message.title === "") {
            setTxtNameIsInValid(true);
            isInvalidForm = true;
        }
        else {
            setTxtNameIsInValid(false);
        }

        if (objMensaje.item_message.body === "") {
            setTxtBodyIsInValid(true);
            isInvalidForm = true;
        }
        else {
            setTxtBodyIsInValid(false);
        }

        if (objMensaje.item_message.topicId <= 0 || objMensaje.item_message.topicId === null) {
            setIsInvalidTemplateSection(true);
            isInvalidForm = true;
        }
        else {
            setIsInvalidTemplateSection(false);
        }

        if (objMensaje.item_message.sectionId === null) {
            setIsInvalidSection(true);
            isInvalidForm = true;
        }
        else {
            setIsInvalidSection(false);
        }

        if (objMensaje.l_section_party_to_ids.length === 0) {
            setIsInvalidSectionParty(true);
            isInvalidForm = true;
        }
        else {
            setIsInvalidSectionParty(false);
        }

        const isManagerPartyMember = inputParam_UserProps && inputParam_UserProps.l_privilegeselement && inputParam_UserProps.l_privilegeselement.find(x => x.managerParty === true) !== undefined;
        if (isManagerPartyMember) {
            if (objMensaje.item_message.answerNeeded && objMensaje.item_message.visa !== null && objMensaje.item_message.visa !== 0) {
                if (objMensaje.item_message.answerDeadlineDate === null) {
                    setPickerAnswerDeadlineDateIsInValid(true);
                    isInvalidForm = true;
                }
                else {
                    setPickerAnswerDeadlineDateIsInValid(false);
                }
            }
        }
        else {
            if (objMensaje.item_message.answerNeeded) {
                if (objMensaje.item_message.answerDeadlineDate === null) {
                    setPickerAnswerDeadlineDateIsInValid(true);
                    isInvalidForm = true;
                }
                else {
                    setPickerAnswerDeadlineDateIsInValid(false);
                }
            }
        }

        if (objMensaje.item_message.visa === 0 && isNullUndefined(distributionGroupUsersList)) {
            isInvalidForm = true;
            setIsInvalidDistributionGroupList(true);
        }
        else {
            setIsInvalidDistributionGroupList(false);

            if (!isNullUndefined(distributionGroupUsersList) && isNullUndefined(distributionGroupUsersList.find(x => x.principal === true))) {
                isInvalidForm = true;
                setIsInvalidDistributionGroupUserList(true);
            }
            else {
                setIsInvalidDistributionGroupUserList(false);
            }
        }
    
        return isInvalidForm;
    }

    const setMessageItemId = (messageId) => {
        let item_message = { ...objMensaje.item_message }
        item_message.id = messageId;
        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message,
            id: messageId
        }));
    }

    const onChangeTemplateSection = (currentNode, selectedNodes) => {
        let items = [...topicList];

        items.forEach(x => {
            if (x.id === currentNode.id) {
                x.checked = currentNode.checked;
            }
            else {
                x.checked = false;
            }
        })

        let item_message = { ...objMensaje.item_message }
        item_message.topicId = currentNode.checked ? currentNode.id : null;
        item_message.messageTopicCode = currentNode.checked ? currentNode.code : null;

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));

        setTopicList(items); 
    }

    const onActionMessage = (statusId) => {     
        setHideActionButtons(true);

        if (isInValidFormControl() === false) {
            objMensaje.book_id = inputParam_BookObject.id;
            objMensaje.item_message.attacheds = documentMessageList.data !== null ? documentMessageList.data.length > 0 : false;
            objMensaje.item_message.statusId = statusId;

            if (objMensaje.id === null || objMensaje.id === 0) {
                objMensaje.id = objMensaje.id === null ? 0 : objMensaje.id;
                objMensaje.item_message.id = objMensaje.item_message.id === null ? 0 : objMensaje.item_message.id;

                //[##CODELCO-CARD-6-##]
                if (inputParam_BookObject.hasMilestone === true && inputParam_BookObject.l_book_milestone.some(x => x.sectionClassId === enum__BOOK_SECTION_CLASS.APERTURA) === true) {
                    //[##CODELCO-CARD-6-##]
                    //Las comunicaciones de hito las envían solamente la parte Administradora
                    if (inputParam_BookObject.needInitMilestone === true) {
                        //[##CODELCO-CARD-6-##]
                        //Usuario no pertenece a la parte administradora que puede enviar la comunicación de inico
                        if (inputParam_BookObject.canStartMilestone === true) {
                            if (inputParam_UserProps.partyId === inputParam_BookObject.milestoneToStartPartyId) {
                                //[##CODELCO-CARD-6-##]
                                //Si se consideran hitos, no se pueden generar otras comunicaciones antes del hito de inicio
                                if (isNullUndefined(objMensaje.l_section_party_to_ids.find(x => x !== inputParam_BookObject.milestoneToStartPartyId))) {
                                        setShowMessage(true)
                                        setMessageType("warning");
                                        setMessage(t('data-lang-msg-destinatinopartynotvalid'))
                                        setHideActionButtons(false);
                                        return;
                                }
                            }
                            else {
                                setMessage(t('data-lang-msg-milestorestartpartynotmember'))
                                setHideActionButtons(false);
                                return;
                            }
                        }
                        else {
                            setMessage(t('data-lang-msg-cantstartmiestone'))
                            setHideActionButtons(false);
                            return;
                        }
                    }

                    //[##CODELCO-CARD-6-##]
                    //Las comunicaciones de hito las envían solamente la parte Administradora
                    if (inputParam_BookObject.canEndMilestone) {
                        //[##CODELCO-CARD-6-##]
                        //Usuario no pertenece a la parte administradora que puede enviar la comunicación de cierre
                        if (inputParam_UserProps.partyId === inputParam_BookObject.milestoneToEndPartyId && objMensaje.item_message.sectionPartySenderId === inputParam_BookObject.milestoneToEndPartyId) {
                            setShowMessage(true)
                            setMessageType("warning");
                            setMessage(t('data-lang-msg-milestoneendnotmember'))
                            setHideActionButtons(false);
                            return;
                        }
                    }
                }

                saveMessage(objMensaje).then(async (response) => {
                    let serviceDocumentStatus = undefined;
                    let serviceDistributionGroupStatus = undefined;
                    //Supuestamente se devolverá el mismo listado pero con ids, esto hará que las opciones de "seleccionar usuario" de las cards nuevas aparezca, dado que ahora la card poseerá id.
                    //El listado retornano no posee los "name" de section y party, es por esto que se establece en null, para que vuelva a buscar los datos con los parametros indicados.
                    //Si es requerido que no se busquen nuevamente los datos, el retorno debe traer las propiedades y se deben asignar.
                    const messageId = response.data.data;
                    
                    if (documentMessageList.data !== null && documentMessageList.data.length > 0) {
                        const documentsToAdd = documentMessageList.data.filter(x => x.onTheFlyDocument === true)

                        const aux_documentsToAdd = []
                        
                        documentsToAdd.map((document, index) => (
                            aux_documentsToAdd.push({
                                id : 0,
                                messageId : messageId,
                                statusId : null,
                                documentId : document.id
                            })
                        ))

                        await addListDocumentByMessage(messageId, aux_documentsToAdd).then((response) => {
                            serviceDocumentStatus = true;
                        }).catch(() => {
                            serviceDocumentStatus = false;
                        });
                    }
                    else {
                        serviceDocumentStatus = true;
                    }

                    if (!isNullUndefined(objMensaje.item_message.visa)) {
                        const principalUser = distributionGroupUsersList.find(x => x.principal === true);

                        if (principalUser) {
                            const aux_visaUsers = {
                                message_id: objMensaje.id === 0 ? response.data.data : objMensaje.id,
                                principal_user_auth_id: principalUser.userAuthProfileId,
                                l_cc_user_auth_id: distributionGroupUsersList.filter(x => x.principal === false).map(x => x.userAuthProfileId)
                            }

                            await saveMessageVisa(aux_visaUsers).then((response) => {
                                serviceDistributionGroupStatus = true;
                            }).catch(() => {
                                serviceDistributionGroupStatus = false;
                            });
                        }
                        else {
                            serviceDistributionGroupStatus = true;
                        }
                    }
                    else {
                        serviceDistributionGroupStatus = true;
                    }

                    if (serviceDocumentStatus === true && serviceDistributionGroupStatus === true) {
                        dispatch(action_setFireBook(true));
                        setMessageItemId(messageId);
                        inputParam_SetterObjMessageList(null);
                        setShowMessage(true);
                        setMessageType("success");
                        setMessage(t('data-lang-msg-operationperformed'));
                    }
                    else if (globalServiceStatus === false || serviceDistributionGroupStatus === false) {
                        setHideActionButtons(false);
                        setMessageItemId(messageId);
                        setShowMessage(true)
                        setMessageType("error");
                        setMessage(t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    setHideActionButtons(false);
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                });
            }
            else {
                updateMessage(objMensaje).then((response) => {
                    //Supuestamente se devolverá el mismo listado pero con ids, esto hará que las opciones de "seleccionar usuario" de las cards nuevas aparezca, dado que ahora la card poseerá id.
                    //El listado retornano no posee los "name" de section y party, es por esto que se establece en null, para que vuelva a buscar los datos con los parametros indicados.
                    //Si es requerido que no se busquen nuevamente los datos, el retorno debe traer las propiedades y se deben asignar.
                    
                    if (response.data.succeeded) {
                        if (documentMessageList.data !== null && documentMessageList.data.length > 0) {

                            const documentsToAdd = documentMessageList.data.filter(x => x.onTheFlyDocument === true)
                            const documents = documentMessageList.data.filter(x => x.onTheFlyDocument !== true)

                            const aux_documentsToAdd = [];

                            documentsToAdd.map((document, index) => (  
                                aux_documentsToAdd.push({
                                    id : 0,
                                    messageId : objMensaje.id,
                                    statusId : null,
                                    documentId : document.id
                                })
                            ))

                            documents.map((document, index) => (  
                                aux_documentsToAdd.push({
                                    id : 0,
                                    messageId : objMensaje.id,
                                    statusId : null,
                                    documentId : document.id
                                })
                            ))

                            const messageId = response.data.data.id;
            
                            addListDocumentByMessage(messageId, aux_documentsToAdd).then((response) => {

                                setDocumentMessageList(prevState => ({
                                    ...prevState,
                                    fireUpdate: true,
                                    data: response.data.data
                                }));

                                setShowMessage(true)
                                setMessageType("success");
                                setMessage(t('data-lang-msg-operationperformed'))
                            }).catch(() => {
                                setHideActionButtons(false);
                                setShowMessage(true)
                                setMessageType("error");
                                setMessage(t('data-lang-msg-operationerror'))
                            });
                        }
                        else {  
                            setShowMessage(true)
                            setMessageType("success");
                            setMessage(t('data-lang-msg-operationperformed'))
                        }
                    }
                    else {
                        setHideActionButtons(false);
                        setShowMessage(true)
                        setMessageType("error");
                        setMessage(t('data-lang-msg-operationerror'))
                    }
                }).catch(() => {
                    setHideActionButtons(false);
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                });
            }
        } else {
            setHideActionButtons(false);
            setShowMessage(true)
            setMessageType("warning");
            setMessage(t('data-lang-msg-requireddatanotset'))
        }
    };

    const onClosePanel = () => {
        onDismissPanel();
    };

    const onDismissPanel = () => {

        setMessage(null);
        setMessageType(null);
        setShowMessage(false);
    
        setDocumentMessageList({fireUpdate: true, data: null, pageNumber: 1, pageSize: 10, filters: []});

        setItemToDelete(null);       
        setTxtNameIsInValid(false)
        setTxtCodeIsInValid(false)
        setTxtBodyIsInValid(false)
        setPickerAnswerDeadlineDateIsInValid(false)
        setIsInvalidSection(false);
        setIsInvalidSectionParty(false);       

        setHideActionButtons(false);

        let sectionListItems = [...sectionList];
        sectionListItems.forEach(x => {
            x.checked = false;
        })
        setSectionList(sectionListItems); 

        if (sectionPartyList !== null) {
            let sectionPartyListItems = [...sectionPartyList];
            sectionPartyListItems.forEach(x => {
                x.checked = false;
            })
            setSectionPartyList(sectionPartyListItems); 
        }

        setObjMensaje({
            id: null,
            book_id: inputParam_BookObject.id,
            section_id: null,
            section_party_member_id: null,
            section_party_from_id: null,
            item_message: { 
                id: null,
                sectionId: null,
                messageNemo: "",
                messageCode: " ",
                correlative: 0,
                title: "",
                body: "",
                topicId: 1,
                senderUsername: inputParam_CurrentUserName,
                sectionPartySenderId: null,
                sendDate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                answerNeeded: false,
                answerToMessage: false,
                answerMessageNemo: null,
                answerMessageId: null,
                answerDeadlineDate: null,
                attacheds: null,
                deactivate: false,
                statusId: null,
                visa: null
            },
            l_section_party_to_ids: []
        });

        inputParam_SetterIsPanelOpen(false);
    };

    const setAditionalDocumentMessageList = (modalDocumentList) => {
        let item_documentList = { ...documentMessageList.data }
        item_documentList = documentMessageList.data !== null ? joinWithoutDupes(documentMessageList.data, modalDocumentList, "id") : modalDocumentList;

        setDocumentMessageList(prevState => ({
            ...prevState,
            fireUpdate: true,
            data: item_documentList
        }));
    }

    const setMessageTitle = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.title = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const setMessageCode = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.messageCode = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const setMessageBody = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.body = (value !== null ? value : "");

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const setMessageAnswerDeadlineDate = (value) => {
        let item_message = { ...objMensaje.item_message }
        item_message.answerDeadlineDate = value.toISOString();

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    }

    const onChangeSection = (currentNode, selectedNodes) => {
        let item_message = { ...objMensaje.item_message }
        item_message.sectionId = (currentNode !== null ? currentNode.id : null);

        let aux = inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === (currentNode !== null ? currentNode.id : null))

        item_message.sectionPartySenderId = inputParam_UserProps.username !== null ? (aux !== undefined ? aux.sectionPartyId : null) : null;

        // los destinatarios son de la sección: al cambiarla hay que volver a elegirlos
        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message,
            section_id: (currentNode !== null ? currentNode.id : null),
            l_section_party_to_ids: [],
            section_party_from_id: item_message.sectionPartySenderId,
            section_party_member_id: inputParam_UserProps.username !== null ? (aux !== undefined ? aux.sectionPartyMemberId : null) : null,
        }));

        let items = [...sectionList];

        items.forEach(x => {
            if (x.id === currentNode.id) {
                x.checked = currentNode.checked;
            }
            else {
                x.checked = false;
            }
        })

        setSectionList(items); 
        setFireEvent(true);
    };

    const onChangeSectionParty = (currentNode, selectedNodes) => {

        let l_section_party_to_ids = { ...objMensaje.l_section_party_to_ids }    
        l_section_party_to_ids = [];
        selectedNodes.forEach(element => {
            l_section_party_to_ids.push(element.id);
        });

        setObjMensaje(prevState => ({
            ...prevState,
            l_section_party_to_ids: l_section_party_to_ids
        }));

        let items = [...sectionPartyList];

        items.forEach(x => {
            x.checked = false;
            selectedNodes.forEach(element => {
                if (x.id === element.id) {
                    x.checked = true;
                }       
            });
        })

        setSectionPartyList(items); 
    };

    const onChangeRequiresAnswer = (e, checked) => {
        let item_message = { ...objMensaje.item_message }
        item_message.answerNeeded = checked;

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const onChangeVisa = (e, checked) => {
        let item_message = { ...objMensaje.item_message }
        const visa = cloneDeep(item_message.visa);
        item_message.visa = checked === false ? null : (visa === null ? 0 : visa);

        setObjMensaje(prevState => ({
            ...prevState,
            item_message: item_message
        }));
    };

    const onDeleteDocumentFromListClick = (item, setItemToDelete) => {
        setItemToDelete(item);
    };

    const onHideDialogAndPanel = () => {
        //onDismissPanel();
        hideDialog();
    };

    const onHideDialog = (ev) => {
        ev.preventDefault();
        inputParam_SetterIsPanelOpen(true);
        hideDialog();
    };



    const onRenderFooterContent = () => {
        return  <Row>
                    <Col xl={12}>
                        <ListPagination
                            listLocalStoragePageSizeVariableName="messageBoxCreatePanelDocuments"
                            data={ documentMessageList }
                            setData={ setDocumentMessageList } />
                    </Col>
                    <Col xl={12} className="message-verybottom-panel-medium">
                        <Message message={ message } display={ showMessage === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                    </Col>
                    <Col xl={12}>
                        <div className='d-flex'>
                            {
                            hideActionButtons === false && sectionList && topicList &&
                                <>
                                    <PrimaryButton
                                        style={{ display: visibilityButtonSaveWMessageId(objMensaje.id, objMensaje.item_message.statusId, inputParam_UserProps, inputParam_BookObject.requiresApproval) ? "none" : "block"}}
                                        onClick={ () => onActionMessage(enum__MessageStatus.ONPRAPARATION) }
                                        styles={_global_buttonStyles}>{ t('data-lang-btn-save') }</PrimaryButton>

                                    <PrimaryButton
                                        style={{ display: visibilityButtonSendToApprove(objMensaje.item_message.statusId, inputParam_UserProps, inputParam_BookObject.requiresApproval) ? "none" : "block"}}
                                        onClick={ () => onActionMessage(enum__MessageStatus.ONAPROBATION) }
                                        styles={_global_buttonStyles}>{ t('data-lang-btn-sendtoapprove') }</PrimaryButton>

                                    <PrimaryButton
                                        style={{ display: visibilityButtonSend(objMensaje.id, objMensaje.item_message.statusId, inputParam_UserProps, inputParam_BookObject.requiresApproval, true) ? "none" : "block" }}
                                        onClick={ () => onActionMessage(objMensaje.item_message.visa === null ? enum__MessageStatus.SENDED : enum__MessageStatus.TOVISA) }
                                        styles={_global_buttonStyles}>{
                                            objMensaje.item_message.visa === null && inputParam_BookObject.requiresApproval !== true ?
                                            t('data-lang-btn-send') : (objMensaje.item_message.visa === null && inputParam_BookObject.requiresApproval === true ? t('data-lang-btn-send') : ((objMensaje.item_message.visa === 0) ? t('data-lang-btn-visa') : t('data-lang-btn-send'))) }</PrimaryButton>
                                </>
                            }
                            <DefaultButton onClick={ onClosePanel }>{ t('data-lang-btn-close') }</DefaultButton>
                        </div>
                    </Col>
                </Row>
    };

    if (itemToDelete !== null) {
        
        if (objMensaje.id === null) {
            setDocumentMessageList(prevState => ({
                ...prevState,
                fireUpdate: true,
                data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
            }));

            setShowMessage(true)
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))
        }
        else {
            removeDocumentByMessageDocument(itemToDelete.id, objMensaje.id).then((response) => {
                if(response.data.succeeded) {

                    setDocumentMessageList(prevState => ({
                        ...prevState,
                        fireUpdate: true,
                        data: documentMessageList.data.filter(x => x.id !== itemToDelete.id)
                    }));
        
                    setShowMessage(true)
                    setMessageType("success");
                    setMessage(t('data-lang-msg-operationperformed'))
                }
                else {
                    setShowMessage(true)
                    setMessageType("error");
                    setMessage(t('data-lang-msg-operationerror'))
                }
            }).catch(() => {
                setShowMessage(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            });
        }
        setItemToDelete(null);
    }

    const sectionFilter = (_sectionList) => {
        const newSectionArray = [];

        _sectionList.forEach(_section => {
            //4->Histórico
            if (_section.sectionClassId !== 4) {
                if (inputParam_UserProps.l_SectionPartyMemberHandler.some(x => x.sectionId === _section.id)) {
                    newSectionArray.push(_section);
                }
            }
        });

        return newSectionArray;
    }

    const manipulateList = (list) => {
        if (list.filter(x => x.key === -1).length === 0) {
            list.unshift({key: -1, text: t('data-lang-lbl-select')})
        }

        return list;
    };

    const onChangeDistributionGruop = (ev, item) => {
        const currentObject = distributionGroupList.find(x => x.id === item.key);
        setSelectedDistributionGroup(!isNullUndefined(currentObject) ? (item.key === -1 ? null : currentObject) : null);
        setFireDistributionGroupSearch(true);
    };

    const onChangePrincipalUserSelectedOption = (ev, option) => {
        distributionGroupUsersList.forEach(element => {
            if (element.id === option.key) {
                element.principal = true;
                element.text = `${element.fullName} (${t('data-lang-lbl-principal')})`
            }
            else {
                element.principal = false;
                element.text = `${element.fullName} (${t('data-lang-lbl-cc')})`
            }
        });

        setDistributionGroupUsersList && setDistributionGroupUsersList(distributionGroupUsersList);
    };
    

    //Render de componente.
    return (
        <div>
            <Panel
                isOpen={ inputParam_IsPanelOpen }
                isLightDismiss={ true }
                onLightDismissClick={ showDialog }
                onDismiss={ onDismissPanel }
                headerText={ t('data-lang-lbl-newmessage') }
                closeButtonAriaLabel={ t('data-lang-btn-close') }
                isFooterAtBottom={ true }
                onRenderFooterContent={ onRenderFooterContent }
                type={PanelType.custom}
                customWidth="60vw"
                 layerProps={{
                    eventBubblingEnabled: true,
                }}
            >
                {
                    sectionList && topicList &&
                    <>
                        <Row className="pt-3">
                            <Col xl={6}>
                                <CTextBox editMode={ false } controlValue={ objMensaje.item_message.messageCode } setterControlValue={ setMessageCode } isInValid={txtCodeIsInValid} textBoxName="code" labelText={ t('data-lang-lbl-code') } />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <Picker
                                    data={ sectionList !== null ? sectionFilter(sectionList) : [] }
                                    mode="simpleSelect"
                                    className="dropdown-checkbox"
                                    isInValid={ isInvalidSection }
                                    texts={{ placeholder: t('data-lang-lbl-choose') }}
                                    onChange={ onChangeSection }
                                    labelText={ t('data-lang-lbl-candidatesections') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ isInvalidSection } />
                            </Col>
                        </Row>
                        <Row className="pt-3">
                            <Col>
                                <Picker
                                    data={ sectionPartyList !== null ? sectionPartyList.filter(x => x.partyId !== inputParam_UserProps.partyId) : [] }
                                    mode="multiSelect"
                                    className="dropdown-checkbox"
                                    isInValid={ isInvalidSectionParty }
                                    texts={{ placeholder: t('data-lang-lbl-choose') }}
                                    onChange={ onChangeSectionParty }
                                    labelText={ t('data-lang-lbl-candidatepartys') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ isInvalidSectionParty } />
                            </Col>
                        </Row>
                        <Row>
                            <Col>
                                <Picker
                                    data={ topicList !== null ? topicList : [] }
                                    mode="simpleSelect"
                                    className="dropdown-checkbox"
                                    isInValid={ isInvalidTemplateSection }
                                    texts={{ placeholder: t('data-lang-lbl-choose') }}
                                    onChange={ onChangeTemplateSection }
                                    labelText={ t('data-lang-lbl-topic') }
                                    refresh={true}
                                />
                                <CValidator isInValid={ isInvalidTemplateSection } />
                            </Col>
                        </Row>
                        <Row>
                            <Col className="pt-3" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <CTextBox controlValue={ objMensaje.item_message.title } setterControlValue={ setMessageTitle } isInValid={txtNameIsInValid} textBoxName="name" labelText={ t('data-lang-lbl-title') } />
                            </Col>
                            <Col className="pt-3" xs={12} sm={6} md={6} lg={6} xl={6}>
                                <Toggle
                                    label={ t('data-lang-lbl-requiresanswer') }
                                    checked={ objMensaje.item_message.answerNeeded }
                                    onChange={ onChangeRequiresAnswer }
                                    role="checkbox"
                                    onText={ t('data-lang-btn-yes') }
                                    className="pt-4 float-start"
                                    offText={ t('data-lang-btn-no') }
                                    styles={ { container:{ paddingTop: "4px" }, root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                />
                            </Col>
                            {
                                !visibilityControlSendToVisa(objMensaje.item_message.statusId, inputParam_UserProps, inputParam_BookObject.requiresApproval) &&
                                <Col className="pt-3" xs={12} sm={3} md={3} lg={3} xl={3}>
                                    <Toggle
                                        label={ t('data-lang-lbl-endorse') }
                                        checked={ objMensaje.item_message.visa === null ? false : objMensaje.item_message.visa >= 0 }
                                        onChange={ onChangeVisa }
                                        role="checkbox"
                                        onText={ t('data-lang-btn-yes') }
                                        className="pt-4 float-start"
                                        offText={ t('data-lang-btn-no') }
                                        styles={ { container:{ paddingTop: "4px" }, root:{float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                                    />
                                </Col>
                            }
                            {
                                (objMensaje.item_message.visa === null) && !visibilityButtonSend(objMensaje.id, objMensaje.item_message.statusId, inputParam_UserProps, inputParam_BookObject.requiresApproval, true) &&
                                <Col className="pt-3" xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <CDatePicker controlValue={ objMensaje.item_message.answerDeadlineDate } setterControlValue={ setMessageAnswerDeadlineDate } isInValid={ pickerAnswerDeadlineDateIsInValid } labelText={ t('data-lang-lbl-answerdeadlinedate') } />
                                </Col>
                            }
                            {
                                !isNullUndefined(distributionGroupList) && !isNullUndefined(objMensaje.item_message.visa) && objMensaje.item_message.visa >= 0 &&
                                <>
                                    <Col xl={12}>
                                        <CLabel labelText={ t('data-lang-lbl-distributiongroup') } /><br/>
                                        <Dropdown
                                            placeholder={t('data-lang-btn-select')}
                                            options={manipulateList(distributionGroupList.map(x => {return {key: x.id, text: x.name}}))}
                                            selectedKey={!isNullUndefined(selectedDistributionGroup) ? selectedDistributionGroup.id : undefined}
                                            onChange={(event, option) => onChangeDistributionGruop(event, option)}
                                            checkable
                                            disabled={false}
                                            styles={ {title: { height: "27px" }} }
                                            className="mb-1 w-100"
                                        />
                                        <CValidator isInValid={isInvalidDistributionGroupList} inValidText={` ${t('data-lang-msg-required')}`} />
                                    </Col>
                                    {
                                        !isNullUndefined(distributionGroupUsersList) &&
                                        <Col xl={12}>
                                            <Card className='mt-3'>
                                                <Card.Body className='border-bottom py-1 px-2'>
                                                    <b>{t('data-lang-lbl-users')}</b>
                                                </Card.Body>
                                                <Card.Body className='py-0 pt-0 pb-2 m-0'>
                                                    <ChoiceGroup
                                                        selectedKey={!isNullUndefined(distributionGroupUsersList.find(x => x.principal === true)) ? distributionGroupUsersList.find(x => x.principal === true).key : undefined}
                                                        options={distributionGroupUsersList}
                                                        onChange={onChangePrincipalUserSelectedOption}
                                                        required={true}
                                                    />
                                                </Card.Body>
                                                <CValidator isInValid={ isInvalidDistributionGroupUserList } />
                                            </Card>
                                        </Col>
                                    }
                                </>
                            }
                            <Col className='text-end pt-3' xl={12}>
                                <ActionButton onClick={() => setIsModalDocumentOpen(true)} iconProps={{ iconName: 'OpenFile' }} allowDisabledFocus disabled={false&&documentUploadDisabled}>
                                    {t('data-lang-btn-documentlilnk')}
                                </ActionButton>
                                {
                                    //[##CODELCO-CARD-4-##] Plantillas de Comunicación
                                    //Se agrega un botón generar desde plantilla, se presiona
                                }
                                <ActionButton onClick={() => setIsTemplatePanelOpen(true)} iconProps={{ iconName: 'WebTemplate' }} allowDisabledFocus disabled={false&&documentUploadDisabled}>
                                    {t('data-lang-btn-usemessagetemplate')}
                                </ActionButton>
                            </Col>
                            <Col className="pt-3" xl={12}>
                            {
                                //[##CODELCO-CARD-4-##] Plantillas de Comunicación
                                //Se agrega un botón generar desde plantilla, se presiona
                                isTemplatePanelOpen !== true &&
                                <CTextArea
                                    labelText={ t('data-lang-lbl-body') }
                                    controlValue={ objMensaje.item_message.body }
                                    setterControlValue={ setMessageBody }
                                    isInvalirControl={ txtBodyIsInValid }
                                    hideToolbarOptions={[
                                        'link',
                                        'unlink',
                                        'image',
                                        'remove'
                                    ]}
                                />
                            }
                            </Col>
                        </Row>

                        <Row className="pt-3" style={{ height: "600px", overflow: "scroll"}}>
                            <Col xl={12}>
                                <List
                                    listLocalStoragePageSizeVariableName="messageBoxCreatePanelDocuments"
                                    className="no-compact-list big-header"
                                    manipulateLocalData={ true }
                                    setData={setDocumentMessageList}
                                    data={documentMessageList}
                                    columns={[
                                        {  
                                            key: 'extension',
                                            name: t('data-lang-lbl-type'),
                                            fieldName: 'extension',
                                            minWidth: 40,
                                            maxWidth: 40,
                                            onRender:(item) => {
                                                return getKeyByValue(__DocumentTypeKeys, item.extension)
                                            }
                                        },
                                        {
                                            key: "documentCode",
                                            name: t('data-lang-lbl-code'),
                                            fieldName: "documentCode",
                                            minWidth: 50,
                                            maxWidth: 100,
                                            isResizable: true
                                        },
                                        {
                                            key: "name",
                                            name: t('data-lang-lbl-name'),
                                            fieldName: "name",
                                            minWidth: 100,
                                            maxWidth: 200,
                                            isResizable: true
                                        },
                                        {
                                            key: "modificationUsername",
                                            name: t('data-lang-lbl-modificationusername'),
                                            fieldName: "modificationUsername",
                                            minWidth: 100,
                                            maxWidth: 100,
                                            isResizable: true
                                        },
                                        {
                                            key: "creationUsername",
                                            name: t('data-lang-lbl-creationusername'),
                                            fieldName: "creationUsername",
                                            minWidth: 100,
                                            maxWidth: 100,
                                            isResizable: true
                                        },
                                        {  
                                            key: 'id',
                                            name: t('data-lang-lbl-actions'),
                                            fieldName: 'id',
                                            //minWidth: "10%",
                                            //maxWidth: "10%",
                                            onRender:(item, row) => {
                                                return <div>
                                                        <OverflowSet
                                                            className="action-menu-list-toolbar d-flex justify-content-center list-menu-action"
                                                            role="menubar"
                                                            items={[
                                                                {
                                                                    key: 'item1',
                                                                    icon: 'Delete',
                                                                    name: t('data-lang-btn-delete'),
                                                                    title: t('data-lang-btn-delete'),
                                                                    onClick: () => onDeleteDocumentFromListClick(item, setItemToDelete),
                                                                }
                                                            ]}
                                                            onRenderOverflowButton={__onRenderOverflowButton}
                                                            onRenderItem={__onRenderOverflowItem}
                                                        />
                                                </div>
                                            }
                                        }  
                                    ]}
                                />
                            </Col>
                        </Row>
                    </>
                } 
                {
                    !(sectionList && topicList) &&
                    <Row className="h-100">
                        <Col className="d-flex align-items-center justify-content-center">
                            <Loading
                                inputParam_ShowLoading={true}
                                inputParam_ShowText={false}
                                inputParam_Width={'35px'}
                                inputParam_Height={'35px'}
                                inputParam_Left={""}
                                inputParam_Style={{marginTop: 0}}
                                inputParam_ColClassName={"me-2"}
                                inputParam_MarginLeft={"auto"}
                                inputParam_SpinnerSize={SpinnerSize.medium} />
                        </Col>
                    </Row>
                }
                {
                    isModalDocumentOpen === true &&
                    <DocumentLinkModal
                        bookObject={inputParam_BookObject}
                        isModalOpen={ isModalDocumentOpen }
                        setIsModalOpen={ setIsModalDocumentOpen }
                        setterSelectedDocumentToLink={ setAditionalDocumentMessageList }
                        userProps={inputParam_UserProps}
                    />
                }
                {
                    //[##CODELCO-CARD-4-##] Plantillas de Comunicación
                    //Al crear la nueva comunicación se abre el panel lateral derecha (flujo actual)
                    isTemplatePanelOpen === true && objMensaje !== null && topicList &&
                    <SidePanelCreateWithTemplate
                        isPanelOpen={isTemplatePanelOpen}
                        setterIsPanelOpen={setIsTemplatePanelOpen}
                        objMessage={objMensaje}
                        topicList={topicList}
                        setTopicList={setTopicList}
                        setterObjMessage={setObjMensaje}
                    />
                }
                <Dialog
                    hidden={!isDialogVisible}
                    onDismiss={onHideDialog}
                    dialogContentProps={{
                        type: DialogType.normal,
                        title: t('data-lang-msg-close-panel'),
                    }}
                    modalProps={{
                        isBlocking: true,
                        styles: { main: { maxWidth: 450 } },
                    }}
                    >
                    <DialogFooter>
                        <PrimaryButton onClick={onHideDialogAndPanel} text={t('data-lang-lbl-yes')} />
                        <DefaultButton onClick={onHideDialog} text={t('data-lang-lbl-no')} />
                    </DialogFooter>
                </Dialog>
            </Panel>            
        </div>
    );
}

export default SidePanelCreate;